import request from '@/utils/request';

// 1. 开通商店
export function upDateStores(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/market',
    method: 'post',
    data: data
  });
}

// 2. 修改商店信息
export function upDateStoresInfo(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/market',
    method: 'PUT',
    data
  });
}

// 3. 获取商店列表
export function fetchStoreList() {
  return request({
    url: '/ajax/markets',
    method: 'get'
  });
}

// 4. 获取商店客户列表
export function fetchStoreCustomersList(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/market/customers',
    method: 'get'
  });
}

// 5. 获取企业商店信息
export function fetchStoreInfo(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/market',
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/stores.js